import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg } from 'utils';
import dayjs from 'dayjs';

export const PROMOTIONS_FETCH_DATA_INIT = createAction('PROMOTIONS_FETCH_DATA_INIT');
export const PROMOTIONS_FETCH_DATA_SUCCESS = createAction(
  'PROMOTIONS_FETCH_DATA_SUCCESS'
);
export const PROMOTIONS_FETCH_DATA_FAIL = createAction('PROMOTIONS_FETCH_DATA_FAIL');

export const PROMOTIONS_DELETE_PROMOTION_INIT = createAction('PROMOTIONS_DELETE_PROMOTION_INIT');
export const PROMOTIONS_DELETE_PROMOTION_SUCCESS = createAction(
  'PROMOTIONS_DELETE_PROMOTION_SUCCESS'
);
export const PROMOTIONS_DELETE_PROMOTION_FAIL = createAction('PROMOTIONS_DELETE_PROMOTION_FAIL');

export const PROMOTIONS_CLEAR_DATA = createAction('PROMOTIONS_CLEAR_DATA');

export const PROMOTIONS_CREATE_PROMOTION_INIT = createAction('PROMOTIONS_CREATE_PROMOTION_INIT');
export const PROMOTIONS_CREATE_PROMOTION_SUCCESS = createAction(
  'PROMOTIONS_CREATE_PROMOTION_SUCCESS'
);
export const PROMOTIONS_CREATE_PROMOTION_FAIL = createAction('PROMOTIONS_CREATE_PROMOTION_FAIL');

export const PROMOTIONS_MODIFY_PROMOTION_INIT = createAction('PROMOTIONS_MODIFY_PROMOTION_INIT');
export const PROMOTIONS_MODIFY_PROMOTION_SUCCESS = createAction(
  'PROMOTIONS_MODIFY_PROMOTION_SUCCESS'
);
export const PROMOTIONS_MODIFY_PROMOTION_FAIL = createAction('PROMOTIONS_MODIFY_PROMOTION_FAIL');

export const PROMOTIONS_CLEAN_UP = createAction('PROMOTIONS_CLEAN_UP');

export const PROMOTIONS_CLEAR_DATA_LOGOUT = createAction('PROMOTIONS_CLEAR_DATA_LOGOUT');
export const PROMOTIONS_SYNC_PROMOTION_INIT = createAction('PROMOTIONS_SYNC_PROMOTION_INIT');
export const PROMOTIONS_SYNC_PROMOTION_SUCCESS = createAction('PROMOTIONS_SYNC_PROMOTION_SUCCESS');
export const PROMOTIONS_SYNC_PROMOTION_FAIL = createAction('PROMOTIONS_SYNC_PROMOTION_FAIL');

export const fetchPromotion = ({
  promotionId,
  siteId,
  type,
  // categoryId = 'all',
  // type = 'published',
}) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(PROMOTIONS_FETCH_DATA_INIT());
    if (promotionId) {
      let promotionData;
      try {
        promotionData = await Axios.get(`${url}/promotion/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          params: {
            siteId,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PROMOTIONS_FETCH_DATA_FAIL({ error }));
      }
      const promotionFind = promotionData.data.data.find((x) => x._id === promotionId);
      const promotion = { ...promotionFind, id: promotionId };
      return dispatch(
        PROMOTIONS_FETCH_DATA_SUCCESS({
          list: getState().promotions.list,
          promotion,
        })
      );
    }

    if (siteId) {
      let promotions;
      try {
        promotions = await Axios.post(
          `${url}/promotion/filter`,
          {
            siteId,
            type,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(PROMOTIONS_FETCH_DATA_FAIL({ error }));
      }
      promotions = promotions.data.data;
      return dispatch(
        PROMOTIONS_FETCH_DATA_SUCCESS({
          list: promotions,
          promotion: getState().promotions.promotion,
        })
      );
    }
  };
};

export const syncPromotion = () => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_SYNC_PROMOTION_INIT());
    Axios.get(`${url}/promotion/fetch`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
      .then(() => {
        return dispatch(PROMOTIONS_SYNC_PROMOTION_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(PROMOTIONS_SYNC_PROMOTION_FAIL({ error }));
      });
  };
};

export const createPromotion = (promotion) => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_CREATE_PROMOTION_INIT());

    // let createPromotion;

    const event = new FormData();
    event.set('path', 'event');
    // event.set('jcr:title', promotion['jcr:title']);
    event.set('Title', promotion.Title);
    event.set('Description', promotion.Description);
    // event.set('jcr:description', promotion['jcr:description']);
    event.set('tenants', JSON.stringify(promotion.tenants));
    event.set('isRibbon', promotion.isRibbon);
    if (promotion.isRibbon) {
      event.set('ribbon', promotion.ribbon);
      event.set('ribboncolor', promotion.ribboncolor);
    }

    event.set(
      'sortimportance',
      promotion.sortimportance ? promotion.sortimportance : '999'
    );

    event.set('siteId', promotion.siteId);
    event.append('file', promotion.file);
    if (promotion.start && promotion.end) {
      event.set(
        'start',
        dayjs.isDayjs(promotion.start)
          ? promotion.start.format()
          : dayjs(promotion.start).format()
      );
      event.set(
        'end',
        dayjs.isDayjs(promotion.end) ? promotion.end.format() : dayjs(promotion.end).format()
      );
    }

    if (promotion.starttime) event.set('starttime', promotion.starttime);
    if (promotion.endtime) event.set('endtime', promotion.endtime);
    // if (promotion.starttime && promotion.endtime) {
    //   event.set(
    //     'starttime',
    //     dayjs.isDayjs(promotion.starttime)
    //       ? promotion.starttime.format()
    //       : dayjs(promotion.starttime).format()
    //   );
    //   event.set(
    //     'endtime',
    //     dayjs.isDayjs(promotion.endtime)
    //       ? promotion.endtime.format()
    //       : dayjs(promotion.endtime).format()
    //   );
    // }

    try {
      await Axios.post(`${url}/promotion/create`, event, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      // let errorMessage;
      // if (error.response) {
      //   errorMessage = error && error.response && error.response.data.message;
      // }

      toastr.error('', 'Please fill in all required fields');
      // toastr.error('', errorMessage);
      return dispatch(
        PROMOTIONS_CREATE_PROMOTION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    const eventJson = JSON.stringify(Object.fromEntries(event));
    toastr.success('', 'Promotion created successfully');
    return dispatch(PROMOTIONS_CREATE_PROMOTION_SUCCESS({ event: eventJson }));
  };
};

export const modifyPromotion = (promotion) => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_MODIFY_PROMOTION_INIT());

    const event = new FormData();
    event.set('path', 'event');
    event.set('id', promotion.id);
    // event.set('jcr:title', promotion['jcr:title']);
    event.set('Title', promotion.Title);
    event.set('Description', promotion.Description);
    if (promotion['jcr:description'])
      event.set('jcr:description', promotion['jcr:description']);
    if (promotion.starttime) event.set('starttime', promotion.starttime);
    event.set('isRibbon', promotion.isRibbon);
    event.set('ribbon', promotion.ribbon);
    event.set('tenants', JSON.stringify(promotion.tenants));
    event.set('ribboncolor', promotion.ribboncolor);
    event.set(
      'sortimportance',
      promotion.sortimportance ? promotion.sortimportance : '999'
    );
    if (promotion.endtime) event.set('endtime', promotion.endtime);
    event.set('siteId', promotion.siteId);
    if (promotion.thumbnail) {
      event.set('thumbnail', promotion.thumbnail);
    }
    event.append('file', promotion.file);

    if (promotion.start && promotion.end) {
      event.set(
        'start',
        dayjs.isDayjs(promotion.start)
          ? promotion.start.format()
          : dayjs(promotion.start).format()
      );
      event.set(
        'end',
        dayjs.isDayjs(promotion.end) ? promotion.end.format() : dayjs(promotion.end).format()
      );
    }
    if (promotion.starttime) event.set('starttime', promotion.starttime);
    if (promotion.endtime) event.set('endtime', promotion.endtime);

    try {
      await Axios.put(`${url}/promotion/edit`, event, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PROMOTIONS_MODIFY_PROMOTION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    const eventJson = JSON.stringify(Object.fromEntries(event));
    toastr.success('', 'Promotion updated successfully');
    return dispatch(PROMOTIONS_MODIFY_PROMOTION_SUCCESS({ eventJson, id: promotion.id }));
  };
};

export const deletePromotion = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(PROMOTIONS_DELETE_PROMOTION_INIT());
    try {
      await Axios.post(
        `${url}/promotion/delete`,
        {
          promotionId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        PROMOTIONS_DELETE_PROMOTION_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The promotion was deleted.');
    cb();
    return dispatch(PROMOTIONS_DELETE_PROMOTION_SUCCESS({ id }));
  };
};

export const promotionsCleanUp = () => (dispatch) => dispatch(PROMOTIONS_CLEAN_UP());
